<template>
  <div>
    <h5 class="pl-2 mt-2">{{text}} Transporter</h5>
    <table class="table" v-if="ready">
      <thead>
        <tr>
          <th>Region</th>
          <th>Total</th>
          <th>Target</th>
          <th>Average Duration</th>
          <th>%Hit Traget<br>(No. of {{ isBySL ? 'SL' : 'Rit' }})</th>
          <th>%Miss Traget<br>(No. of {{ isBySL ? 'SL' : 'Rit' }})</th>
          <th>1-4 Days</th>
          <th>5-6 Days</th>
          <th>7-9 Days</th>
          <th>> 10 Days</th>
        </tr>
      </thead>
      <tbody v-for="(transport) in Object.keys(regionStats)" :key="transport">
        <tr>
          <td style="text-decoration: underline;"><b>{{ transport }}</b></td>
          <td>{{numberWithCommas(regionStats[transport].total)}}</td>
          <td>{{regionStats[transport].target}} Day{{(regionStats[transport].target > 1) ? 's' : ''}} </td>
          <td>{{ regionStats[transport].avg }} Day{{(regionStats[transport].avg > 1) ? 's' : ''}}</td>
          <td>{{ (Math.round(regionStats[transport].hit_target / regionStats[transport].total * 1000) / 10).toFixed(1) }} % ({{ numberWithCommas(regionStats[transport].hit_target == '-' ? 0 : regionStats[transport].hit_target) }})</td>
          <td>{{ (Math.round(regionStats[transport].miss_target / regionStats[transport].total * 1000) / 10).toFixed(1) }}% ({{ numberWithCommas(regionStats[transport].miss_target == '-' ? 0 : regionStats[transport].miss_target) }})</td>
          <td>{{ (Math.round(regionStats[transport].day_1_4 / regionStats[transport].total * 1000) / 10).toFixed(1) }}%</td>
          <td>{{ (Math.round(regionStats[transport].day_5_6 / regionStats[transport].total * 1000) / 10).toFixed(1) }}%</td>
          <td>{{ (Math.round(regionStats[transport].day_7_9 / regionStats[transport].total * 1000) / 10).toFixed(1) }}%</td>
          <td>{{ (Math.round(regionStats[transport].day_10 / regionStats[transport].total * 1000) / 10).toFixed(1) }}%</td>


        </tr>
        <template  v-for="dat in ((showAll) ? data : data.slice(0, 2))">
          <tr v-if="dat.region == transport">
            <td>{{ dat.gudang}}</td>
            <td>{{numberWithCommas(dat.total)}}</td>
            <td>{{ dat.target }} Day{{(dat.target > 1) ? 's' : ''}}</td>
            <td>{{ dat.avg }} Day{{(dat.avg > 1) ? 's' : ''}}</td>
            <td>{{ (Math.round(dat.hit_target / dat.total * 1000) / 10).toFixed(1) }} % ({{ numberWithCommas(dat.hit_target == '-' ? 0 : dat.hit_target) }})</td>
            <td>{{ (Math.round(dat.miss_target / dat.total * 1000) / 10).toFixed(1) }}% ({{ numberWithCommas(dat.miss_target == '-' ? 0 : dat.miss_target) }})</td>
            <td>{{ (Math.round(dat.day_1_4 / dat.total * 1000) / 10).toFixed(1) }}%</td>
            <td>{{ (Math.round(dat.day_5_6 / dat.total * 1000) / 10).toFixed(1) }}%</td>
            <td>{{ (Math.round(dat.day_7_9 / dat.total * 1000) / 10).toFixed(1) }}%</td>
            <td>{{ (Math.round(dat.day_10 / dat.total * 1000) / 10).toFixed(1) }}%</td>
          </tr>
        </template>
        <tr v-if="showAllButton">
          <td v-if="!showAll" colspan="9" class="moreButton" @click="showAll = true">Lihat Semua</td>
          <td v-else colspan="9" class="moreButton" @click="showAll = false">Sembunyikan</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        showAllButton : false,
        showAll : true,
        regionStats : {},
        ready : false,
        totalData : {}
      }
    },
    watch : {
      type : function () {
        this.calculateRegion()
      }
    },
    props:['filter','period', 'data' , 'type' ,'text', 'isBySL'],
    mounted () {
      this.calculateRegion()
    },
    methods : {
      calculateRegion () {
        delete this.regionStats
        this.regionStats = {}
        this.totalData = {}
        this.ready = false
        for (var i = 0 ; i < this.data.length ; i++) {
          let obj = this.regionStats
          
          let keys = Object.keys(this.data[i])

          for (var j = 0 ; j < keys.length ; j ++) {
            if(keys[j] == 'name' || keys[j] == 'gudang') continue

            if(this.data[i][keys[j]] == '-') {
              obj[this.data[i].region][keys[j]] = '-'
              continue
            }

            if(obj[this.data[i].region]) {
              obj[this.data[i].region][keys[j]] ? obj[this.data[i].region][keys[j]] += parseFloat(this.data[i][keys[j]]) : obj[this.data[i].region][keys[j]] = parseFloat(this.data[i][keys[j]])
            }
            else {
              obj[this.data[i].region] = {}
              obj[this.data[i].region][keys[j]] ? obj[this.data[i].region][keys[j]] += parseFloat(this.data[i][keys[j]]) : obj[this.data[i].region][keys[j]] = parseFloat(this.data[i][keys[j]])
            }

            if(keys[j] == 'region') {
              obj[this.data[i].region][keys[j]] = this.data[i][keys[j]]
              this.totalData[this.data[i].region] ? this.totalData[this.data[i].region]++ : this.totalData[this.data[i].region] = 1
              continue
            }

          }

        }
        this.$emit('insertRegionStats' , this.regionStats , this.totalData)
        this.ready = true
      }
    }
  }
</script>

<style scoped>
  table tr th, table tr td {
    text-align: center;
    vertical-align: middle;
  }

  table tr th {
    border-bottom: 1px solid #F75047;
  }

</style>